import { createAction, props } from '@ngrx/store';
import { CompanyContact } from '../_models/companyContact';

// Action types
export const loadCompanyContacts = createAction('[CompanyContact] Load CompanyContacts');
export const loadCompanyContactsSuccess = createAction(
  '[CompanyContact] Load CompanyContacts Success',
  props<{ companyContacts: CompanyContact[] }>()
);
export const loadCompanyContactsFailure = createAction(
  '[CompanyContact] Load CompanyContacts Failure',
  props<{ error: any }>()
);

export const addCompanyContact = createAction(
  '[CompanyContact] Add CompanyContact',
  props<{ companyContact: CompanyContact }>()
);
export const addCompanyContactSuccess = createAction(
  '[CompanyContact] Add CompanyContact Success',
  props<{ companyContact: CompanyContact }>()
);
export const addCompanyContactFailure = createAction(
  '[CompanyContact] Add CompanyContact Failure',
  props<{ error: any }>()
);

export const updateCompanyContact = createAction(
  '[CompanyContact] Update CompanyContact',
  props<{ companyContact: CompanyContact }>()
);
export const updateCompanyContactSuccess = createAction(
  '[CompanyContact] Update CompanyContact Success',
  props<{ companyContact: CompanyContact }>()
);
export const updateCompanyContactFailure = createAction(
  '[CompanyContact] Update CompanyContact Failure',
  props<{ error: any }>()
);

export const deleteCompanyContact = createAction(
  '[CompanyContact] Delete CompanyContact',
  props<{ id: number }>()
);
export const deleteCompanyContactSuccess = createAction(
  '[CompanyContact] Delete CompanyContact Success',
  props<{ id: number }>()
);
export const deleteCompanyContactFailure = createAction(
  '[CompanyContact] Delete CompanyContact Failure',
  props<{ error: any }>()
);
